import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { text, spacing } = theme;

export const descriptionGrid = css`
  padding: 0 !important;
  grid-row-gap: 0 !important;
  grid-template-areas:
    'overview'
    'description'
    'extraDetails';

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-template-rows: auto 1fr;
      grid-template-areas:
        'description overview'
        'description extraDetails';
    `,
  )}
`;

export const description = css`
  min-width: 0;
  grid-column: 1 / -1;
  grid-area: description;
  grid-column: span 12;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 2 / span 7;
    `,
  )}
`;

export const sideSection = css`
  grid-column: 1 / -1;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-column: span 6;
    `,
  )}

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 9 / span 3;
    `,
  )}
`;

export const overview = css`
  grid-area: overview;
  grid-column: span 12;
`;

export const extraDetails = css`
  grid-area: extraDetails;
  grid-column: span 12;
`;

export const heading = css`
  font-size: ${text.HEADING.XS.fontSize}px;
  margin-top: ${pxToRem(spacing.xxl)};
  margin-bottom: ${pxToRem(spacing.lg)};
`;

export const ingredientsInfo = css`
  padding: ${pxToRem(theme.spacing.sm)} 0;
`;

export const thumbnails = css`
  margin-left: ${pxToRem(theme.spacing.md)};
  padding-top: ${pxToRem(theme.spacing.md)};
`;
